import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=6883587e&scoped=true"
import script from "./Partner.vue?vue&type=script&lang=js"
export * from "./Partner.vue?vue&type=script&lang=js"
import style0 from "./Partner.vue?vue&type=style&index=0&id=6883587e&prod&lang=less"
import style1 from "./Partner.vue?vue&type=style&index=1&id=6883587e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6883587e",
  null
  
)

export default component.exports